import { createContext, useContext } from 'react';

/**
 * Что выбрали щелчком на сайте в живом предпросмотре: блок или поле. Блок
 * разворачивается и показывается в форме, поле — тоже.
 *
 * Контекст, а не проп: блоки живут глубоко внутри формы (запись → поля →
 * поле «блоки»), и тащить выбор через каждый уровень значило бы менять их
 * все ради одного случая.
 */
export interface PreviewFocus {
  block?: string;
  field?: string;
  /** Новый щелчок по тому же блоку — снова показать его. */
  nonce: number;
}

export const PreviewFocusContext = createContext<PreviewFocus | undefined>(undefined);

export function usePreviewFocus(): PreviewFocus | undefined {
  return useContext(PreviewFocusContext);
}

/** Показать элемент формы: прокрутить к нему и коротко подсветить. */
export function reveal(element: Element | null): void {
  if (!(element instanceof HTMLElement)) {
    return;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.setAttribute('data-flash', '');
  window.setTimeout(() => {
    element.removeAttribute('data-flash');
  }, 1600);
}

/** Адрес записи на сайте по шаблону типа; шаблона или адреса нет — undefined. */
export function previewAddress(
  base: string | undefined,
  route: string,
  record: { id: string; slug?: string | undefined },
  adminOrigin: string,
): string | undefined {
  if (base === undefined || base === '' || route === '') {
    return undefined;
  }

  if (route.includes('{slug}') && (record.slug === undefined || record.slug === '')) {
    return undefined;
  }

  const path = route.replace('{slug}', record.slug ?? '').replace('{id}', record.id);
  const url = new URL(path, base.endsWith('/') ? base : `${base}/`);

  url.searchParams.set('faceta-preview', adminOrigin);

  return url.toString();
}
